import { Link } from "react-router-dom";
// import clsx from "clsx";
// import { KTIcon } from "../../helpers";
import { useLayout } from "../../layout/core";
import { MutableRefObject, useEffect, useRef } from "react";
import { ToggleComponent } from "../../assets/ts/components";
import { useAuth } from "hooks‬/Auth";

type PropsType = {
  sidebarRef: MutableRefObject<HTMLDivElement | null>;
};

const SidebarLogo = (props: PropsType) => {
  const { config } = useLayout();
  const { userDetails } = useAuth();
  const toggleRef = useRef<HTMLDivElement>(null);

  // const appSidebarDefaultMinimizeDesktopEnabled =
  //   config?.app?.sidebar?.default?.minimize?.desktop?.enabled;
  // const appSidebarDefaultCollapseDesktopEnabled =
  //   config?.app?.sidebar?.default?.collapse?.desktop?.enabled;
  // const toggleType = appSidebarDefaultCollapseDesktopEnabled
  //   ? "collapse"
  //   : appSidebarDefaultMinimizeDesktopEnabled
  //   ? "minimize"
  //   : "";
  // const toggleState = appSidebarDefaultMinimizeDesktopEnabled ? "active" : "";
  // const appSidebarDefaultMinimizeDefault =
  //   config.app?.sidebar?.default?.minimize?.desktop?.default;

  useEffect(() => {
    setTimeout(() => {
      const toggleObj = ToggleComponent.getInstance(
        toggleRef.current!
      ) as ToggleComponent | null;

      if (toggleObj === null) {
        return;
      }

      // Add a class to prevent sidebar hover effect after toggle click
      toggleObj.on("kt.toggle.change", function () {
        // Set animation state
        props.sidebarRef.current!.classList.add("animating");

        // Wait till animation finishes
        setTimeout(function () {
          // Remove animation state
          props.sidebarRef.current!.classList.remove("animating");
        }, 300);
      });
    }, 600);
  }, [toggleRef, props.sidebarRef]);

  return (
    <div
      className="app-sidebar-logo m-2  mb-0 border-0   rounded"
      id="n_one_app_sidebar_logo"
    >
      <Link to="/dashboard">
        {config.layoutType === "dark-sidebar" ? (
          <img
            alt="company-logo"
            src={userDetails?.rebranding?.companyLogo || "/NBlight.svg"}
            className="logo-header app-sidebar-logo-default"
          />
        ) : (
          <>
            <img
              alt="company-logo"
              src={userDetails?.rebranding?.companyLogo || "/NBdark.svg"}
              className="logo-header app-sidebar-logo-default theme-dark-show"
            />

            <img
              alt="company-logo"
              src={userDetails?.rebranding?.companyLogo || "/NBlight.svg"}
              className="logo-header app-sidebar-logo-default theme-light-show"
            />
          </>
        )}
      </Link>

      {/* {(appSidebarDefaultMinimizeDesktopEnabled ||
        appSidebarDefaultCollapseDesktopEnabled) && (
        <div
          ref={toggleRef}
          className={clsx(
            " btn text-white    btn btn-icon btn-sm  bg-dark h-30px w-30px   translate-middle rotate border border-1 border-white",
            { active: appSidebarDefaultMinimizeDefault }
          )}
          data-kt-toggle="true"
          data-kt-toggle-state={toggleState}
          data-kt-toggle-target="body"
          data-kt-toggle-name={`app-sidebar-${toggleType}`}
          style={{
            position: "absolute",
            right: "-30px",
            top: "30px",
          }}
        >
          <KTIcon
            iconName="black-left-line"
            className="fs-2 rotate-180 text-white"
          />
        </div>
      )} */}
    </div>
  );
};

export { SidebarLogo };
